const getActiveClass = (active: boolean) => {
  return active ? 'content-row content-row-active' : 'content-row';
};

export default getActiveClass;
